import { Check, X, Trash2 } from 'react-feather';

export interface SelectionActionBarProps {
  selectedCount: number;
  onClear: () => void;
  onDelete: () => void;
  /** Custom label for delete button. Defaults to "Delete selected (N)" */
  deleteLabel?: string;
}

function SelectionActionBar({
  selectedCount,
  onClear,
  onDelete,
  deleteLabel,
}: SelectionActionBarProps) {
  if (selectedCount === 0) return null;

  const label = deleteLabel ?? `Delete selected (${selectedCount})`;

  return (
    <div className="flex items-center gap-4 p-3 mb-4 bg-red-500/5 border border-red-500/20 rounded-xl">
      <div className="flex items-center gap-2 px-3 py-1.5 bg-red-500/10 rounded-lg">
        <div className="w-5 h-5 rounded-md bg-red-500 flex items-center justify-center">
          <Check className="w-3 h-3 text-white" strokeWidth={3} />
        </div>
        <span className="text-sm font-semibold text-red-600">{selectedCount} selected</span>
      </div>
      <div className="flex-1" />
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onClear}
          className="h-8 px-3 flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 rounded transition-colors"
        >
          <X className="w-3.5 h-3.5" />
          Clear
        </button>
        <button
          type="button"
          onClick={onDelete}
          className="h-8 px-4 flex items-center gap-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition-colors"
        >
          <Trash2 className="w-3.5 h-3.5" />
          {label}
        </button>
      </div>
    </div>
  );
}

SelectionActionBar.defaultProps = {
  deleteLabel: undefined,
};

export default SelectionActionBar;
